import { render, staticRenderFns } from "./MobileClassSelector.vue?vue&type=template&id=12646fee&scoped=true"
import script from "./MobileClassSelector.vue?vue&type=script&lang=js"
export * from "./MobileClassSelector.vue?vue&type=script&lang=js"
import style0 from "./MobileClassSelector.vue?vue&type=style&index=0&id=12646fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12646fee",
  null
  
)

export default component.exports